import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

import { toast } from "react-toastify";
import { cancelTaskAPI } from "../../apis/Product";

export default function NotificationModal({
  open,
  setOpen,
  taskId,
  closeDrawer,
  clearPolling,
}) {
  const cancelTask = async () => {
    const res = await cancelTaskAPI(taskId);
    clearPolling();
    console.log("API RESPONSE ", res);
    if (res.data.success) {
      setOpen(false);
      closeDrawer(false);
      toast.success("Task Canceled Successfully", {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        // pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      setOpen(false);
      toast.error("Unable to cancel task", {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        // pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to cancel?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ paddingX: 3, paddingBottom: 3 }}>
          <Button variant="contained" color="primary" onClick={handleClose}>
            No
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={cancelTask}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
